import {deepFreeze} from 'shared/utils/custom-utils';

export const validity = deepFreeze({
    VALIDITY_CHECK_ERROR: 'error'
});

export type State =
    'NORMAL' |
    'EDITING' |
    'INITIAL' |
    'FINAL' |
    'QUESTION' |
    'PROCESSING' |
    'CHANGED';

type StateDefinition = {
    [name in State]: State;
};

export const states: StateDefinition = deepFreeze<StateDefinition>({
    NORMAL: 'NORMAL',
    EDITING: 'EDITING',
    INITIAL: 'INITIAL',
    FINAL: 'FINAL',
    QUESTION: 'QUESTION',
    PROCESSING: 'PROCESSING',
    CHANGED: 'CHANGED'
});

export const responseTypes = deepFreeze({
    EXCEPTION: 'Exception',
    INTERRUPT: 'Interrupt',
    ACKNOWLEDGE: 'Acknowledge',
    FINISHED_RESPONSE: 'FinishedResponse',
    PAYLOAD: 'Payload',
    REDIRECTION: 'RedirectionResponse',
    PRINT_PAGE: 'PrintPage',
    RICH_TEXT_FINISHED_RESPONSE: 'RichTextFinishedResponse',
});

export const exceptionTypes = deepFreeze({
    FEATURE_NOT_ENABLED_EXCEPTION: 'FeatureNotEnabledException',
});

export const recordTypes = deepFreeze({
    TYPE_DOCUMENT: 'document',
    TYPE_AUTHORITY: 'authority'
});

export const actionRequestMethods = deepFreeze({
    GET: 'get',
    POST: 'post',
    DELETE: 'delete'
});

export enum SearchType {
    TYPE_FIELDS = 'fields',
    TYPE_SEARCH_SELECTION = 'search-selection',
    TYPE_MOST_WATCHED = 'most-watched',
    TYPE_NEWEST = 'newest',
    TYPE_TOP_RATED = 'top-rated',
    TYPE_MOST_LENT = 'most-lent',
    TYPE_DOCUMENT_INDEX = 'document-index',
    TYPE_AUTHORITY_INDEX = 'authority-index',
    TYPE_EXEMPLAR_SEARCH = 'exemplar-search',
    TYPE_USER_SEARCH = 'user-search',
    TYPE_FILE_SEARCH = 'file-search',
    TYPE_RECORD_OPERATION_SEARCH = 'record-operation-search',
    TYPE_RECORD_REQUEST_SEARCH = 'record-request-search',
    TYPE_SELECTION_ITEM_SEARCH = 'selection-item-search',
    TYPE_PAYMENT_SEARCH = 'payment-search',
    TYPE_INVENTORY_SEARCH = 'inventory-search',
    TYPE_CAPTURE_SEARCH = 'capture-search',
    TYPE_MATCH_SEARCH = 'match-search',
    TYPE_LOAN_SEARCH = 'loan-search',
    TYPE_GLOBAL = 'global',
    TYPE_FORM = 'complex',
    TYPE_BY_AUTHORITY = 'by-authority',
    TYPE_LOAN_REMINDER = 'loan-reminder-search'
}

export enum Kind {
    KIND_DOCUMENT = 'document',
    KIND_AUTHORITY = 'authority',
    KIND_EXEMPLAR = 'exemplar',
    KIND_USER = 'user',
    KIND_PAYMENT = 'payment',
    KIND_INVENTORY = 'inventory',
    KIND_CAPTURE = 'capture',
    KIND_MATCH = 'match',
    KIND_FILE = 'file',
    KIND_RECORD_OPERATION = 'record-operation',
    KIND_RECORD_REQUEST = 'record-request',
    KIND_SELECTION_ITEM = 'selection-item',
    KIND_LOAN = 'loan',
    KIND_LOAN_REMINDER = 'loan-reminder'
}

export enum DatasourceGroup {
    EXTERNAL = 'external-'
}

export enum RECORD_COLLECTION_CATEGORY_ID {
    FAVOURITES = '005e8650-3e13-4c02-ba6c-a46d680d4bf1',
    PRIVATE = '99715646-f0c0-4607-bcb6-924abbe733cb',
    OTHER = 'b0a41fbc-1724-4ebd-aa9d-3e64d9308173',
}